import { User } from '../screens/user/Users';
import { LocalStorage } from './storage';

const localStorage = new LocalStorage('user');
class UserManager {
  public getUser() {
    const userString = localStorage.getItem('user');
    if (!userString) return;
    const user = JSON.parse(userString) as User;
    return user;
  }
  public setUser(user: User) {
    localStorage.setItem('user', JSON.stringify({ ...user }));
  }
  public clearUser() {
    localStorage.removeItem('user');
  }
}
const userManager = new UserManager();
export { userManager };



// WEBPACK FOOTER //
// ./src/services/user.ts